import Separator from '../../Separator/Separator';
import styles from './DropdownSeparator.module.css';

const DropdownSeparator = () => {

    return (
        <Separator className={styles.DropdownSeparator} />
    )

}

export default DropdownSeparator;
